export default "__VITE_ASSET__CMNz_cPy__"